// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3NgEO","buttons":"RemoveExpirationActionButtons_buttons__2qyrZ"};